var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86.57 189.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232323;}.cls-2{fill:#004568;}.cls-3{fill:#f3b792;}.cls-4{fill:#13adb2;}.cls-5{fill:#0d5279;}.cls-6{fill:#50290a;}.cls-7{fill:#1299a1;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Male_03a",
    "data-name": "Staff_Male_03a",
    viewBox: "0 0 86.57 189.7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.78,168.33s3.72,1.59,3.79,3.2c.1,2.39-2.39,5.78-5.19,9s-3.78,4.57-9.28,3.5c-4.58-.9-5.55-3-6.15-3.81s-.17-3.46,3.19-3c3.59.5,2.86,1.12,3.86-.28s2-6,2-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.4,88.92c1,7.39,1.2,31.73,2.19,41.5s10,36.72,10,36.72-1.43,2.38-5.79,4.39a18.39,18.39,0,0,1-10.57,1.19c-2.2-8.18-9-25.74-10.78-33.92s-5.18-22.14-6.18-27.73-1.8-15.16-1.8-15.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.26,181.9c.6,4.19,1,6.5-1.18,7.27-3,1.08-5.4.51-11.59-1.68-6.64-2.36-10-4.58-10.8-7s1.91-3.7,6.81-2.61C38.68,179.74,48.11,182.23,47.26,181.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.12,56l-5.39,3s-7.36-16.11-7-17.71,1.6-6.78,1.6-6.78l-2.2-.8S11,30.91,10.78,30.11s-2.6-1.8-4.79-.6S-.14,34.29,0,35.3c.4,2.79,4.19,5.58,4.59,7S8.62,63,10.75,67c1.8,3.33,3.4,4.92,4.39,4.78,3-.4,12.57-4.59,16-7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.91,30.86l4.19,1.2,4,9,10-.2L35.89,28.67c-.2-5.19-.8-8.78-2.79-8.78s-7.19.6-8.18,1.79-.79,3.56-.79,3.56,3-1,3.38.43S26.91,30.86,26.91,30.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.88,8.71c-2.11,6.65-1.19,16.37-.6,19.56s4.79,2.39,4.79,2.39l1.4,5.79,16.16-1.2-2.39-7.38c3.39-6.39,5.58-14.77,3.39-19.55s-7.78-6.19-12.17-6S40.28,4.32,38.88,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.84,31.26a9.88,9.88,0,0,1,12.77-4c3.14,1.65,4.38,6.38,4,10.38S70,49,70,49L55.24,39.44A59.7,59.7,0,0,1,58.84,31.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.69,94.51c-.6,9.78-2.19,33.32-2.59,41.9s.6,21.35,1,28.93.2,13.77.2,13.77,3,3.59,7.18,4,6.58.8,9.38-1c.2-2-.2-25.94.2-37.91s7.58-26.34,9.37-34.52a131.81,131.81,0,0,0,2.4-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46,18.88s1-2.79,3.39-2.79,3.19,2.59,3.19,4.39a4.88,4.88,0,0,1-3,4.19,6.41,6.41,0,0,0,2.22,4c3.1,2.21,7.19.6,8.78-2.6s6-13.76,2.6-19.35S51.05-.86,45.47.33s-8.18,3.6-9,5.39-.63,8.33,5.16,8.53C42.65,17.44,42.05,19.68,46,18.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.1,53c-.13-5-.2-12,4.59-14.57,3.1-1.68,12.53-3.95,19.15-6.58,3.58-1.42,5.08-4.19,7.18-4.19,6,0,9.58,1.79,10,13.17s.2,26.14.4,32.72S76,91.32,76,91.32s-4.38,9-21.14,9S33.3,96.5,33.3,96.5C33.7,79.55,33.3,60.79,33.1,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.67,32.66l-1.59,4.39s10.37,1.39,16.56-.6,4.79-4.79,4.79-4.79L60,27.87s-4.19,4.19-8.38,4.59A77,77,0,0,1,42.67,32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.72,54.21c2.79-2.6,5-4.59,6.78-7.39s6-8.18,11.38-5,7,12,.4,17.35S31.5,66.38,31.5,66.38c-3,2-6.58-2.2-7.38-4.59S21.86,55.93,23.72,54.21Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 86.57,
    height: 189.7,
    xlinkHref: "#Staff_Male_03a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff5A);
export default __webpack_public_path__ + "static/media/staff-5-a.73abea1b3595660c1308e871bc175d6e.svg";
export { ForwardRef as ReactComponent };